var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#293c43;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.56,476.58V292.63H245.92v36.79H172.34v36.79h73.58V403H172.34v73.58ZM245.92,329.42h36.79v36.79H245.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.07,439.79h73.58v36.79H356.29V292.63h36.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M541.11,476.58V329.42H577.9v36.79h73.57V329.42h36.79V476.58H651.47V403H577.9v73.58ZM577.9,292.63v36.79h73.57V292.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M761,292.63h36.78v36.79H761Zm36.78,36.79h36.79v36.79H797.74Zm36.79,147.16V366.21h36.79V476.58Zm36.79-147.16h36.79v36.79H871.32Zm36.79-36.79H944.9v36.79H908.11Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.54,799V595.58H185.4v50.87H287.13V595.58H338V799H287.13V697.31H185.4V799ZM185.4,544.72v50.86H287.13V544.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.5,799V544.72H591.09v50.86H489.36v50.87H591.09v50.86H489.36V799ZM540.23,697.31h50.86v50.86H540.23Zm50.86-101.73H642v50.87H591.09Zm0,152.59H642V799H591.09Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.68,799V544.72h152.6v50.86H794.55V748.17H896.28V799ZM947.14,595.58V748.17H896.28V595.58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormal);
export default __webpack_public_path__ + "static/media/Formal.71f7a653cc753c10e3c255a7a6bd1faa.svg";
export { ForwardRef as ReactComponent };